import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from "react-intl";
import { createSelector } from 'reselect';
import { set, setMulti,setOpenAdvanceFiltersDialog } from '../../../store/actions/pages';
import { setV2 } from '../../../store/actions/pagesV2';

import ContractsTopFilterComponent from './ContractsTopFilter';

export const ContractsTopFilter = connect(
    () => {

        const selectCustomFilter = createSelector(
            (state) => state.pages['contracts-landing'],
            (table) => {
                return table.customFilter;
            }
        );

        const selectPending = createSelector(
            (state) => state.pages['contracts-landing'],
            (table) => {
                return table.pending;
            }
        );

        return (state, props) => ({
            customFilter: selectCustomFilter(state),
            relativeFilterValue: state.claimAnalysis.relativeFilterValue,
            contractState: state?.pagesV2['contractsv2-landing'].contractState,
            pending: selectPending(state)
        });
    },
    (dispatch) => ({
        actions: bindActionCreators({
            setMulti: obj => setMulti('contracts-landing', obj),
            setContractState: (value) => setV2('contractsv2-landing', 'contractState', value),
            setOpenAdvanceFiltersDialog
        }, dispatch)
    })
)(injectIntl(ContractsTopFilterComponent));